import { useAuth } from '@orrekie/shared';
import { Link } from 'react-router-dom';

import { getDefaultPostLoginPath } from '../lib/productCapabilities';
import type { ProductTierAudience } from '../lib/productTier';

type UserShellTopbarProps = {
  audience?: ProductTierAudience;
};

export function UserShellTopbar({ audience = 'workbench' }: UserShellTopbarProps) {
  const { user, claims } = useAuth();
  const identity =
    user?.displayName?.trim() || user?.email?.split('@')[0]?.trim() || user?.email || 'Account';

  if (audience === 'free') {
    return (
      <div
        data-testid="user-shell-topbar"
        className="flex flex-wrap items-center justify-end gap-x-3 gap-y-1 text-sm text-[var(--ui-shell-text)]"
      >
        <span className="truncate max-w-[18rem] font-medium" data-testid="user-shell-identity" title={user?.email ?? undefined}>
          {user?.email || identity}
        </span>
      </div>
    );
  }

  const org =
    (typeof claims?.orgName === 'string' && claims.orgName.trim()) ||
    (typeof (claims as { organizationName?: string } | null)?.organizationName === 'string' &&
      (claims as { organizationName?: string }).organizationName?.trim()) ||
    (typeof claims?.orgId === 'string' && claims.orgId.trim()) ||
    'Organization';

  return (
    <div
      data-testid="user-shell-topbar"
      className="flex flex-wrap items-center justify-end gap-x-3 gap-y-1 text-sm text-[var(--ui-shell-text)]"
    >
      <Link
        to={getDefaultPostLoginPath()}
        className="truncate max-w-[14rem] font-medium hover:underline"
        data-testid="user-shell-org-link"
        title="Organization home"
      >
        {org}
      </Link>
      <span className="text-[var(--ui-sidebar-muted-text)] select-none" aria-hidden>
        |
      </span>
      <Link to="/profile" className="font-medium hover:underline" data-testid="user-shell-profile-link">
        {identity}
      </Link>
    </div>
  );
}
